import axios from 'axios';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router';

import * as apiGetAllIdentityProviders from 'api/identityProvider/GetIndetityProviderGetAllV1';
import LoginForm from 'components/desktop/User/Login/LoginForm';
import LogoAnimation from 'components/desktop/_general/LogoAnimation/LogoAnimation';
import 'containers/desktop/User/Login/Login.scss';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { useJwt } from 'hooks/useJwt';
import ITokens from 'interfaces/ITokens';
import { defaultLoginDto } from 'types/User/Login/LoginDto';

const Login = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [loginDto, setLoginDto] = useState(defaultLoginDto);
	const [identityProviders, setIdentityProviders] = useState<
		apiGetAllIdentityProviders.IdentityProvider[]
	>([]);
	const navigate = useNavigate();
	const { login, accessJwt } = useJwt();

	useEffect((): void => {
		retrieveIdentityProviders();
	}, []);

	useEffect((): void => {
		if (!accessJwt) return;
		navigateToUrl();
	}, [accessJwt]);

	const retrieveIdentityProviders = async () => {
		const response = await apiGetAllIdentityProviders.callApi();
		response.do((x) => setIdentityProviders(x.identityProviders));
	};

	const navigateToUrl = (): void => {
		const pathname: string | null = localStorage.getItem('pathname');
		localStorage.removeItem('pathname');
		navigate(pathname ?? '/reports');
	};

	const handleLogin = async () => {
		setIsLoading(true);
		try {
			await login(loginDto.email, loginDto.password);
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const [extLogoVisible, setExtLogoVisible] = useState<boolean>(true);
	const extLogoPath = '/img/logoExt/external_logo_login.png';

	const setExtLogoInvisible = (): void => {
		setExtLogoVisible(false);
	};

	const renderContent = () => {
		return (
			<>
				<section>
					<div className="wave">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div>
						<Card className="login-inner-container">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
								}}
							>
								<div style={{ transform: 'scale(0.8)', transformOrigin: 'center' }}>
									<LogoAnimation />
								</div>
								<span
									style={{
										color: '#6066C1',
										fontWeight: 'bold',
										fontSize: '1rem',
									}}
								>
									Artificial Intelligence Recipes
								</span>
								{extLogoVisible && (
									<>
										<hr
											style={{
												height: '1px',
												width: '100%',
												backgroundColor: 'gray',
												border: 'none',
											}}
										/>
										<img
											src={extLogoPath}
											onError={setExtLogoInvisible}
											style={{
												maxHeight: '80px',
												maxWidth: '220px',
											}}
											className="d-inline-block align-text-middle"
										/>
									</>
								)}
							</div>

							<Card.Body className="login-inner-container-div">
								<LoginForm
									loginDto={loginDto}
									identityProviders={identityProviders}
									setLoginDto={setLoginDto}
									handleLogin={handleLogin}
									isLoading={isLoading}
								/>
							</Card.Body>
						</Card>
					</div>
				</section>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default Login;
